import { ConnectionDto } from "@arelia-types/connection"
import ConnectionCard from "./ConnectionCard";
import { useState } from "react";
import BasicDialog from "../dialogs/BasicDialog";
import { Box } from "@mui/material";

type Props = {
  connection: ConnectionDto,
}

export default function BasicConnection({ connection }: Props) {
  const [open, setOpen] = useState<boolean>(false);

  return <Box>
    <ConnectionCard {...connection} onConnect={() => setOpen(true)} />
    {open && <BasicDialog
      canDisconnect={true}
      connection={connection}
      onClose={() => setOpen(false)}
    />}
  </Box>;
}